/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */

import React, { Component } from 'react';
import {
  FormGroup,
  Button,
  AccordionItem,
  Accordion,
  DataTable,
  TableContainer,
  TableToolbar,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableHeader,
  TableCell,
  TableToolbarContent,
  TextInput,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ComposedModal,
} from 'carbon-components-react';
import Delete16 from '@carbon/icons-react/lib/delete/16';
import Close16 from '@carbon/icons-react/lib/close/16';
import Add16 from '@carbon/icons-react/lib/add/16';
import PropTypes from 'prop-types';
import { showNotification } from '../../../helpers/notification/BaseNotification';
import { getError, entitiesLabels } from '../../../helpers/Constants';
import AuditorComboBox from './AuditorComboBox';
import {
  NoRecordsPlaceholder,
  RenderDataTableCell,
} from '../../../helpers/jsonschemaform/DataTableExtention';
import EmployerComboBox from './EmployerComboBox';
import { FindGHRSEmployer } from '../../common/FindGHRSEmployer';
import SimpleReactValidator from 'simple-react-validator';
export default class Personnel extends Component {
  constructor(props) {
    super(props);
    this.validatorAuditors = new SimpleReactValidator();
    this.validatorAuditees = new SimpleReactValidator();
      this.state = {
      selectedAuditor: null,
      selectedAuditees: null,
      modalAuditorDeleteVisible: false,
      modalNewAuditorVisible: false,
      modalAuditeesDeleteVisible: false,
      modalNewAuditeesVisible: false,
      isOpenModalGHRS: false,
      model: {
        fullname: null,
        name: null,
        surname: null,
        email: null,
        company: null,
        teamLeader: false,
        role: 'Auditor',
      },
      modelNoSaipem: {
        fullname: null,
        name: null,
        surname: null,
        email: null,
        company: null,
        teamLeader: false,
        role: 'AuditorNoSaipem',
      },
      modelAuditees: {
        fullname: null,
        name: null,
        surname: null,
        email: null,
        company: null,
        teamLeader: false,
        role: 'Auditee',
      },
      modelAuditeesNoSaipem: {
        fullname: null,
        name: null,
        surname: null,
        email: null,
        company: null,
        teamLeader: false,
        role: 'Auditee',
      },
      mode: props.mode || 0,
      modeAuditees: props.mode || 0,
    };

    this.onAuditorsDelete = this.onAuditorsDelete.bind(this);
    this.onAuditeesDelete = this.onAuditeesDelete.bind(this);
    this.onAuditorsChange = this.onAuditorsChange.bind(this);
    this.onAuditeesChange = this.onAuditeesChange.bind(this);
    this.onAuditorsChangeConfirm = this.onAuditorsChangeConfirm.bind(this);
    this.onAuditorsGHRSConfirm = this.onAuditorsGHRSConfirm.bind(this);
    this.onAuditeesChangeConfirm = this.onAuditeesChangeConfirm.bind(this);
    this.onAuditorsDeleteConfirm = this.onAuditorsDeleteConfirm.bind(this);
    this.onAuditeesDeleteConfirm = this.onAuditeesDeleteConfirm.bind(this);
    this.handleDeleteAuditorModal = this.handleDeleteAuditorModal.bind(this);
    this.handleDeleteAuditeesModal = this.handleDeleteAuditeesModal.bind(this);
    this.handleNewAuditorModal = this.handleNewAuditorModal.bind(this);
    this.handleNewAuditeesModal = this.handleNewAuditeesModal.bind(this);
    this.CloseAuditeeModal = this.CloseAuditeeModal.bind(this);
    this.CloseAuditorModal = this.CloseAuditorModal.bind(this);
    this.handleChangeGHRSModal = this.handleChangeGHRSModal.bind(this);
    this.handleChangeGHRSModalOpen = this.handleChangeGHRSModalOpen.bind(this);
    this.setEmployer = this.setEmployer.bind(this);
  }
  setEmployer = (employer) => {
    if (employer && employer.id) {
      const selectedAuditees = this.props.auditees || [];

      const exists = selectedAuditees.some((v) => v.ghrS_ID === employer.ghrS_ID);
      if (!exists) {
        this.props.auditees.concat([employer]);
        const newAuditees = this.props.auditees.concat([employer]);
        employer.idEmployer = employer.id;
        let statusCopy = { ...this.state.selectedAuditees };
        statusCopy = newAuditees;
        this.setState({ selectedAuditees: statusCopy });
        this.props.onAuditeesAdd(employer);
        this.setState({ modalNewAuditeesVisible: false, modeAuditees: 0 });
        this.renderAuditees();
      } else {
        showNotification.error(`${entitiesLabels.ERROR}`, 'inspected already on the list');
      }
    }
  };
  handleChangeGHRSModal() {
    this.setState((oldState) => ({
      isOpenModalGHRS: !oldState.isOpenModalGHRS,
      modeAuditees: 0,
      selectedAuditees: null,
    }));
  }

  handleChangeGHRSModalOpen() {
    this.setState((oldState) => ({
      isOpenModalGHRS: !oldState.isOpenModalGHRS,
      selectedAuditees: null,
    }));
  }

  onAuditorsGHRSConfirm() {
    if (this.state.selectedAuditor != null) {
      const { selectedAuditor } = this.state;
      selectedAuditor.idEmployer = selectedAuditor.id;
      selectedAuditor.teamLeader = false;
      selectedAuditor.role = 'Auditor';
      this.props.onAuditorAdd(selectedAuditor);
      this.setState((oldState) => ({
        modalNewAuditorVisible: !oldState.modalNewAuditorVisible,
        mode: 0,
        selectedAuditor: null,
      }));
    }
  }

  onAuditorsChangeConfirm() {
    if (this.state.selectedAuditor != null) {
      const { selectedAuditor } = this.state;
      selectedAuditor.idEmployer = selectedAuditor.id;
      selectedAuditor.teamLeader = false;
      selectedAuditor.role = 'Auditor';
      this.props.onAuditorAdd(selectedAuditor);
    } else {
      if (this.validatorAuditors.allValid()) {
        let selectedAuditor = this.state.modelNoSaipem;
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (re.test(String(selectedAuditor.email).toLowerCase())) {
          this.props.onAuditorAdd(selectedAuditor);
        } else {
          showNotification.warning(`${entitiesLabels.WARNING} `, ' Auditor error email ');
        }
        this.setState((oldState) => ({
          modalNewAuditorVisible: !oldState.modalNewAuditorVisible,
          mode: 0,
          modelNoSaipem: {
            fullname: null,
            name: null,
            surname: null,
            email: null,
            company: null,
            teamLeader: false,
            role: 'AuditorNoSaipem',
          },
        }));
      } else {
        this.validatorAuditors.showMessages();
        showNotification.warning(
          `${entitiesLabels.WARNING} `,
          'Auditor required fields are missing'
        );
        this.forceUpdate();
      }
    }
  }

  onAuditeesChangeConfirm() {
    if (this.validatorAuditees.allValid()) {
      if (this.state.selectedAuditees != null) {
        const { selectedAuditees } = this.state;
        selectedAuditees.idEmployer = selectedAuditees.id;
        selectedAuditees.role = 'Auditee';
        this.props.onAuditeesAdd(selectedAuditees);
      } else {
        let selectedAuditees = this.state.modelAuditeesNoSaipem;
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (re.test(String(selectedAuditees.email).toLowerCase())) {
          this.props.onAuditeesAdd(selectedAuditees);
        } else {
          showNotification.warning(`${entitiesLabels.WARNING}`, 'Auditee error email ');
        }
      }
      this.setState((oldState) => ({
        modalNewAuditeesVisible: !oldState.modalNewAuditeesVisible,
        modeAuditees: 0,
        modelAuditeesNoSaipem: {
          name: null,
          surname: null,
          email: null,
          ghrS_ID: null,
        },
      }));
    } else {
      this.validatorAuditees.showMessages();
      showNotification.warning(
        `${entitiesLabels.WARNING}`,
        'Auditee required fields are missing  '
      );
      this.forceUpdate();
    }
  }

  onAuditorsDeleteConfirm() {
    this.props.onAuditorDelete(this.state.selectedAuditor);
    this.setState((oldState) => ({
      modalAuditorDeleteVisible: !oldState.modalAuditorDeleteVisible,
    }));
  }

  onAuditeesDeleteConfirm() {
    this.props.onAuditeesDelete(this.state.selectedAuditees);
    this.setState((oldState) => ({
      modalAuditeesDeleteVisible: !oldState.modalAuditeesDeleteVisible,
    }));
  }

  onAuditorsChange(selectedItem) {
    this.setState({ selectedAuditor: selectedItem });
  }

  onAuditeesChange(selectedItem) {
    this.setState({ selectedAuditees: selectedItem });
  }

  onAuditorsDelete(Id) {
    const selectedItem = this.props.auditors.find((item) => item.id === Id);
    this.setState((oldState) => ({
      selectedAuditor: selectedItem,
      modalAuditorDeleteVisible: !oldState.modalAuditorDeleteVisible,
    }));
  }

  onAuditeesDelete(Id) {
    const selectedItem = this.props.auditees.find((item) => item.id === Id);
    this.setState((oldState) => ({
      selectedAuditees: selectedItem,
      modalAuditeesDeleteVisible: !oldState.modalAuditeesDeleteVisible,
    }));
  }
  handleChangeMode = (m) => {
    this.setState({ mode: m });
  };
  handleChangeModeAuditees = (m) => {
    this.setState({ modeAuditees: m });
  };
  updateState = (inputName, inputValue, objName) => {
    let statusCopy = Object.assign({}, this.state);
    statusCopy[objName][inputName] = inputValue;

    this.setState(statusCopy);
  };
  handleChangeModel = (el) => {
    let inputName = el.target.name;
    let inputValue = el.target.value;
    let objName = el.target.alt;
    this.updateState(inputName, inputValue, objName);
  };
  handleNewAuditorModal() {
    if (this.state.mode == 1 || this.state.mode == 3) {
      this.setState({
        mode: 0,
        selectedAuditor: null,
        model: {
          name: null,
          surname: null,
          email: null,
          ghrS_ID: null,
        },
        modelNoSaipem: {
          name: null,
          surname: null,
          email: null,
          ghrS_ID: null,
        },
      });
    } else {
      this.setState((oldState) => ({
        modalNewAuditorVisible: !oldState.modalNewAuditorVisible,
        selectedAuditor: null,
      }));
    }
  }

  handleNewAuditeesModal() {
    if (this.state.modeAuditees == 0) {
      this.setState((oldState) => ({
        modalNewAuditeesVisible: !oldState.modalNewAuditeesVisible,
        modeAuditees: 0,
        selectedAuditees: null,
        modelAuditees: {
          name: null,
          surname: null,
          email: null,
          ghrS_ID: null,
        },
        modelAuditeesNoSaipem: {
          name: null,
          surname: null,
          email: null,
          ghrS_ID: null,
        },
      }));
    } else {
      this.setState((oldState) => ({
        modeAuditees: 0,
        selectedAuditees: null,
      }));
    }
  }

  CloseAuditeeModal() {
    this.setState((oldState) => ({
      modalNewAuditeesVisible: !oldState.modalNewAuditeesVisible,
      modeAuditees: 0,
      selectedAuditees: null,
      modelAuditeesNoSaipem: {
        name: null,
        surname: null,
        email: null,
        ghrS_ID: null,
      },
    }));
  }
  CloseAuditorModal() {
    this.setState((oldState) => ({
      modalNewAuditorVisible: !oldState.modalNewAuditorVisible,
      mode: 0,
      selectedAuditor: null,
      modelNoSaipem: {
        name: null,
        surname: null,
        email: null,
        ghrS_ID: null,
      },
    }));
  }

  handleDeleteAuditorModal() {
    this.setState((oldState) => ({
      modalAuditorDeleteVisible: !oldState.modalAuditorDeleteVisible,
    }));
  }

  handleDeleteAuditeesModal() {
    this.setState((oldState) => ({
      modalAuditeesDeleteVisible: !oldState.modalAuditeesDeleteVisible,
    }));
  }

  renderDeleteAuditorModal = () =>
    this.state.modalAuditorDeleteVisible && (
      <div className="bx--modal bx--modal-tall is-visible">
        <div className="bx--modal-container">
          <div className="bx--modal-header">
            <h3 className="bx--modal-header__heading">Delete Team Member</h3>
            <Button
              className="bx--modal-close"
              renderIcon={Close16}
              onClick={this.handleDeleteAuditorModal}
            />
          </div>

          <div className="bx--modal-content">
            <div className="bx--row  bx--modal-content-detail">
              <div className="bx--col-lg-12 bx--col-md-12">
                <h5 className="align-center">
                  {`Press confirm to remove ${this.state.selectedAuditor.fullName} from Team Members`}
                </h5>
              </div>
            </div>
          </div>
          <div className="bx--modal-footer">
            <Button
              className="button--max-width"
              kind="secondary"
              onClick={this.handleDeleteAuditorModal}
            >
              Cancel
            </Button>
            <Button
              className="button--max-width"
              kind="primary"
              onClick={this.onAuditorsDeleteConfirm}
            >
              Confirm
            </Button>
          </div>
        </div>
      </div>
    );

  renderDeleteAuditeesModal = () =>
    this.state.modalAuditeesDeleteVisible && (
      <div className="bx--modal bx--modal-tall is-visible">
        <div className="bx--modal-container">
          <div className="bx--modal-header">
            <h3 className="bx--modal-header__heading">Delete Team Member</h3>
            <Button
              className="bx--modal-close"
              renderIcon={Close16}
              onClick={this.handleDeleteAuditeesModal}
            />
          </div>

          <div className="bx--modal-content">
            <div className="bx--row bx--modal-content-detail">
              <div className="bx--col-lg-12 bx--col-md-12">
                <h5 className="align-center">
                  {`Press confirm to remove ${this.state.selectedAuditees.fullname} from Team Members`}
                </h5>
              </div>
            </div>
          </div>
          <div className="bx--modal-footer">
            <Button
              className="button--max-width"
              kind="secondary"
              onClick={this.handleDeleteAuditeesModal}
            >
              Cancel
            </Button>
            <Button
              className="button--max-width"
              kind="primary"
              onClick={this.onAuditeesDeleteConfirm}
            >
              Confirm
            </Button>
          </div>
        </div>
      </div>
    );

  renderNewAuditorModal = (validations, isOpenModal) =>
    this.state.modalNewAuditorVisible && (
      <ComposedModal
        className="light-modal"
        open={isOpenModal}
        danger="false"
        onClose={() => {
          return false;
        }}
      >
        <ModalHeader className="margin-modal" onClick={this.CloseAuditorModal}>
          <p>Add New Auditor</p>
        </ModalHeader>
        <ModalBody className="margin-modal">
          {this.state.mode == 0 ? (
            <div className="bx--row two-button-center modal--elemnts-buttons">
              <Button
                kind="primary"
                className="bx--col-md-6"
                onClick={() => this.handleChangeMode(1)}
              >
                Saipem research
              </Button>
              <Button
                kind="primary"
                className="bx--col-md-6"
                onClick={() => this.handleChangeMode(3)}
              >
                Manual input
              </Button>
            </div>
          ) : this.state.mode == 1 ? (
            <div className="margin-fieldset">
              <FormGroup legendText="Auditor">
                <AuditorComboBox
                  onChange={this.onAuditorsChange}
                  onError={(error) => {
                    showNotification.error(
                      `${entitiesLabels.AUDIT} notification: `,
                      getError(error, 'loading data loading auditor', 'ERROR')
                    );
                  }}
                  itemsToExclude={this.props.auditors}
                  division={this.props.division}
                  disabled={false}
                  //userDivision={this.props.userDivision} //B1_Audit_Module_Optimization
                />
              </FormGroup>
            </div>
          ) : (
            <div className="bx--grid--full-width">
              <div className="bx--row">
                <FormGroup legendText="Name*" className="bx--col-md-4 bx--col-lg-6">
                  <TextInput
                    id="name"
                    name="name"
                    alt="modelNoSaipem"
                    placeholder="Input Name"
                    //value={this.state.model.name != null?  this.state.model.name : this.state.model.employer ? this.state.model.employer.name : ''}
                    type="text"
                    hideLabel={true}
                    labelText=""
                    // disabled={this.state.model.idEmployer != null}
                    onChange={this.handleChangeModel}
                    invalid={validations.name != null}
                  />
                  {validations.name}
                </FormGroup>
                <FormGroup legendText="Surname*" className="bx--col-md-4 bx--col-lg-6">
                  <TextInput
                    id="txt-surname"
                    name="surname"
                    alt="modelNoSaipem"
                    placeholder="Input Surname"
                    // value={  this.state.model.surname ?   this.state.model.surname: this.state.model.employer ? this.state.model.employer.surname :'' }
                    type="text"
                    hideLabel={true}
                    labelText=""
                    // disabled={this.state.model.idEmployer != null}
                    onChange={this.handleChangeModel}
                    invalid={validations.surname != null}
                  />
                  {validations.surname}
                </FormGroup>
                <FormGroup legendText="Company" className="bx--col-md-4 bx--col-lg-6">
                  <TextInput
                    id="txt-badgeNumber"
                    name="company"
                    alt="modelNoSaipem"
                    placeholder="Input Company"
                    // value={this.state.model.ghrS_ID ?   this.state.model.ghrS_ID: this.state.model.employer ? this.state.model.employer.ghrS_ID : '' }
                    type="text"
                    hideLabel={true}
                    labelText=""
                    //disabled={this.state.model.idEmployer != null}
                    onChange={this.handleChangeModel}
                  />
                </FormGroup>
                <FormGroup legendText="Email* (Personal Email Addresses are not allowed)" className="bx--col-md-4 bx--col-lg-6">
                  <TextInput
                    id="txt-email"
                    name="email"
                    alt="modelNoSaipem"
                    placeholder="Input Email"
                    // value={this.state.model.email ?   this.state.model.email :  this.state.model.employer ? this.state.model.employer.email : ''  }
                    type="text"
                    hideLabel={true}
                    labelText=""
                    //disabled={this.state.model.idEmployer != null}
                    onChange={this.handleChangeModel}
                    invalid={validations.email != null}
                    title="&#9888; Do Not use Personal Accounts"
                  />
                  {validations.email}
                </FormGroup>
              </div>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button kind="secondary" onClick={this.CloseAuditorModal}>
            Cancel
          </Button>
          <Button
            kind="primary"
            disabled={
              this.state.modelNoSaipem.name == null &&
              this.state.modelNoSaipem.surname == null &&
              this.state.modelNoSaipem.email == null &&
              !this.state.selectedAuditor
            }
            onClick={
              this.state.mode == 1 ? this.onAuditorsGHRSConfirm : this.onAuditorsChangeConfirm
            }
          >
            Confirm
          </Button>
        </ModalFooter>
      </ComposedModal>
    );

  renderNewAuditeesModal = (validations, isOpenModal) =>
    this.state.modeAuditees == 1 ? (
      <FindGHRSEmployer
        isOpenModal={this.state.modeAuditees == 1}
        onCancel={this.CloseAuditeeModal}
        onOk={this.setEmployer}
      />
    ) : this.state.modalNewAuditeesVisible ? (
      <ComposedModal
        className="light-modal"
        open={isOpenModal}
        danger="false"
        onClose={() => {
          return false;
        }}
      >
        <ModalHeader className="margin-modal" onClick={this.CloseAuditeeModal}>
          <p>Add New Auditee</p>
        </ModalHeader>
        <ModalBody className="margin-modal">
          {this.state.modeAuditees == 0 ? (
            <div className="bx--row two-button-center modal--elemnts-buttons">
              <Button
                kind="primary"
                className="bx--col-md-6"
                onClick={() => this.handleChangeModeAuditees(1)}
              >
                GHRS research
              </Button>
              <Button
                kind="primary"
                className="bx--col-md-6"
                onClick={() => this.handleChangeModeAuditees(3)}
              >
                Manual input
              </Button>
            </div>
          ) : (
            <div className="bx--grid--full-width">
              <div className="bx--row">
                <FormGroup legendText="Name*" className="bx--col-md-4 bx--col-lg-6">
                  <TextInput
                    id="name"
                    name="name"
                    alt="modelAuditeesNoSaipem"
                    placeholder="Input Name"
                    //value={this.state.model.name != null?  this.state.model.name : this.state.model.employer ? this.state.model.employer.name : ''}
                    type="text"
                    hideLabel={true}
                    labelText=""
                    // disabled={this.state.model.idEmployer != null}
                    onChange={this.handleChangeModel}
                    invalid={validations.name != null}
                  />
                  {validations.name}
                </FormGroup>
                <FormGroup legendText="Surname*" className="bx--col-md-4 bx--col-lg-6">
                  <TextInput
                    id="txt-surname"
                    name="surname"
                    alt="modelAuditeesNoSaipem"
                    placeholder="Input Surname"
                    // value={  this.state.model.surname ?   this.state.model.surname: this.state.model.employer ? this.state.model.employer.surname :'' }
                    type="text"
                    hideLabel={true}
                    labelText=""
                    // disabled={this.state.model.idEmployer != null}
                    onChange={this.handleChangeModel}
                    invalid={validations.surname != null}
                  />
                  {validations.surname}
                </FormGroup>
                <FormGroup legendText="Company" className="bx--col-md-4 bx--col-lg-6">
                  <TextInput
                    id="txt-badgeNumber"
                    name="company"
                    alt="modelAuditeesNoSaipem"
                    placeholder="Input Company"
                    // value={this.state.model.ghrS_ID ?   this.state.model.ghrS_ID: this.state.model.employer ? this.state.model.employer.ghrS_ID : '' }
                    type="text"
                    hideLabel={true}
                    labelText=""
                    //disabled={this.state.model.idEmployer != null}
                    onChange={this.handleChangeModel}
                  />
                </FormGroup>
                <FormGroup legendText="Email* (Personal Email Addresses are not allowed)" className="bx--col-md-4 bx--col-lg-6">
                  <TextInput
                    id="txt-email"
                    name="email"
                    alt="modelAuditeesNoSaipem"
                    placeholder="Input Email"
                    // value={this.state.model.email ?   this.state.model.email :  this.state.model.employer ? this.state.model.employer.email : ''  }
                    type="text"
                    hideLabel={true}
                    labelText=""
                    title="&#9888; Do Not use Personal Accounts"
                    //disabled={this.state.model.idEmployer != null}
                    onChange={this.handleChangeModel}
                    invalid={validations.email != null}
                  />
                  {validations.email}
                </FormGroup>
              </div>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button kind="secondary" onClick={this.CloseAuditeeModal}>
            Cancel
          </Button>
          <Button
            kind="primary"
            disabled={
              this.state.modelAuditeesNoSaipem.name == null &&
              this.state.modelAuditeesNoSaipem.surname == null &&
              this.state.modelAuditeesNoSaipem.email == null &&
              !this.state.selectedAuditees
            }
            onClick={this.onAuditeesChangeConfirm}
          >
            Confirm
          </Button>
        </ModalFooter>
      </ComposedModal>
    ) : (
      ''
    );

  renderAuditors = () => {
    this.validatorAuditors.purgeFields();
    const validationsAuditors = {
      name: this.validatorAuditors.message('name', this.state.modelNoSaipem.name, 'required'),
      surname: this.validatorAuditors.message(
        'surname',
        this.state.modelNoSaipem.surname,
        'required'
      ),
      email: this.validatorAuditors.message(
        'email',
        this.state.modelNoSaipem.email,
        'required|email'
      ),
    };
    const isOpenModal = true;
    const headers = [
      {
        key: 'fullName',
        header: 'Name',
        isSortable: true,
      },
      {
        key: 'email',
        header: 'Email',
      },
      {
        key: 'role',
        header: 'Position',
      },
      {
        key: 'teamLeader',
        header: '',
      },
      {
        key: 'external',
        header: 'External',
        type: 'bool',
      },
    ];
    return (
      <DataTable
        useZebraStyles
        rows={this.props.auditors}
        headers={headers}
        render={({ rows, getHeaderProps }) => (
          <TableContainer>
            <TableToolbar>
              <TableToolbarContent className="table-toolbar-custom-content">
                <div className="bx--col-lg-8 bx--col-md-10 table-toolbar-custon-content-info-start">
                  <h6>List</h6>
                </div>
                <div className="bx--col-lg-4 bx--col-md-2 table-toolbar-custon-content-info-end ">
                            {!this.state.isDisabled && !this.props.maskedValue && ( //RITM1133680 Start - Anonimization AUDIT Module
                                <Button
                                    onClick={this.handleNewAuditorModal}
                                    kind="primary"
                                    renderIcon={Add16}
                                    disabled={this.props.disabled}
                                >
                                    Add New Auditor
                                </Button>
                            )}
                </div>
              </TableToolbarContent>
            </TableToolbar>
            {this.renderDeleteAuditorModal()}
            {this.renderNewAuditorModal(validationsAuditors, isOpenModal)}
            <Table>
              <TableHead>
                <TableRow>
                  {headers.map((header) => (
                    <TableHeader
                      {...getHeaderProps({ header })}
                      className={header.type == 'bool' ? 'align-center' : ''}
                    >
                      {header.header}
                    </TableHeader>
                  ))}
                  <TableHeader className="align-center">Actions</TableHeader>
                </TableRow>
              </TableHead>
              <TableBody>
                {!rows ? (
                  <NoRecordsPlaceholder labelText="No Records" colSpan={3} />
                ) : (
                  rows.map((row) => (
                    <TableRow key={`row_${row.id}`}>
                      {row.cells.map((cell) => (
                        <RenderDataTableCell
                          key={cell.id}
                          cell={cell}
                          header={headers.find((x) => x.key === cell.info.header)}
                          maskedValue={this.props.maskedValue} //RITM1133680
                        />
                      ))}
                      <TableCell key="action" className="tableActions align-center">
                              {!this.state.isDisabled && !this.props.maskedValue && ( //RITM1133680 Start - Anonimization AUDIT Module
                                  <div>
                                      <Button
                                          onClick={() => this.onAuditorsDelete(row.id)}
                                          disabled={
                                              this.props.disabled ||
                                              row.cells.find((item) => item.info.header === 'teamLeader').value
                                          }
                                          size="small"
                                          renderIcon={Delete16}
                                          iconDescription="Delete"
                                          kind="ghost"
                                      />
                                  </div>
                              )}
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      />
    );
  };

  renderAuditees = () => {
    this.validatorAuditees.purgeFields();
    const validationsAuditee = {
      name: this.validatorAuditees.message(
        'name',
        this.state.modelAuditeesNoSaipem.name,
        'required'
      ),
      surname: this.validatorAuditees.message(
        'surname',
        this.state.modelAuditeesNoSaipem.surname,
        'required'
      ),
      email: this.validatorAuditees.message(
        'email',
        this.state.modelAuditeesNoSaipem.email,
        'required|email'
      ),
    };
    const isOpenModal = true;
    const headers = [
      {
        key: 'fullName',
        header: 'Name',
        isSortable: true,
      },
      {
        key: 'email',
        header: 'Email',
      },
      {
        key: 'role',
        header: 'Position',
      },
      {
        key: 'external',
        header: 'External',
        type: 'bool',
      },
    ];
    return (
      <DataTable
        useZebraStyles
        rows={this.props.auditees}
        headers={headers}
        render={({ rows, getHeaderProps }) => (
          <TableContainer>
            <TableToolbar>
              <TableToolbarContent className="table-toolbar-custom-content">
                <div className="bx--col-lg-8 bx--col-md-10 table-toolbar-custon-content-info-start ">
                  <h6>List</h6>
                </div>
                <div className="bx--col-lg-4 bx--col-md-2 table-toolbar-custon-content-info-end">
                            {!this.state.isDisabled && !this.props.maskedValue && ( //RITM1133680 Start - Anonimization AUDIT Module
                                <Button
                                    onClick={this.handleNewAuditeesModal}
                                    kind="primary"
                                    renderIcon={Add16}
                                    disabled={this.props.disabled}
                                >
                                    Add New Auditee
                                </Button>
                            )}
                </div>
              </TableToolbarContent>
            </TableToolbar>
            {this.renderDeleteAuditeesModal()}
            {this.renderNewAuditeesModal(validationsAuditee, isOpenModal)}

            <Table>
              <TableHead>
                <TableRow>
                  {headers.map((header) => (
                    <TableHeader
                      {...getHeaderProps({ header })}
                      className={header.type == 'bool' ? 'align-center' : ''}
                    >
                      {header.header}
                    </TableHeader>
                  ))}
                  <TableHeader className="align-center">Actions</TableHeader>
                </TableRow>
              </TableHead>
              <TableBody>
                {!rows ? (
                  <NoRecordsPlaceholder labelText="No Records" colSpan={3} />
                ) : (
                  rows.map((row) => (
                    <TableRow key={`row_${row.id}`}>
                      {row.cells.map((cell) => (
                        <RenderDataTableCell
                          key={cell.id}
                          cell={cell}
                          header={headers.find((x) => x.key === cell.info.header)}
                          maskedValue={this.props.maskedValue} //RITM1133680
                        />
                      ))}
                      <TableCell key="action" className="tableActions align-center">
                              {!this.state.isDisabled && !this.props.maskedValue && ( //RITM1133680 Start - Anonimization AUDIT Module
                                  <div>
                                      <Button
                                          onClick={() => this.onAuditeesDelete(row.id)}
                                          size="small"
                                          renderIcon={Delete16}
                                          iconDescription="Delete"
                                          kind="ghost"
                                          disabled={this.props.disabled}
                                      />
                                  </div>
                              )}
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      />
    );
  };

  render() {
    return (
      <div className="bx--row">
        <Accordion>
          <AccordionItem
            className="auditAccordionTitle"
            title="Auditors"
            id={`AccordionAuditors${this.props.id}`}
            key={`AccordionAuditors${this.props.id}`}
          >
            <div className="bx--row">
              <div className="bx--col-lg-12 bx--col-md-12 bx--col-sm-12">
                {this.renderAuditors()}
              </div>
            </div>
          </AccordionItem>
          <AccordionItem
            className="auditAccordionTitle"
            title="Auditees"
            id={`AccordionAuditees${this.props.id}`}
            key={`AccordionAAuditees${this.props.id}`}
          >
            <div className="bx--row">
              <div className="bx--col-lg-12 bx--col-md-12 bx--col-sm-12">
                {this.renderAuditees()}
              </div>
            </div>
          </AccordionItem>
        </Accordion>
      </div>
    );
  }
}

Personnel.propTypes = {
  id: PropTypes.string.isRequired,
  auditees: PropTypes.array.isRequired,
  employees: PropTypes.array.isRequired,
  auditors: PropTypes.array.isRequired,
  division: PropTypes.string.isRequired,
  onAuditorAdd: PropTypes.func.isRequired,
  onAuditorDelete: PropTypes.func.isRequired,
  onAuditeesAdd: PropTypes.func.isRequired,
  onAuditeesDelete: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  isOpenModal: PropTypes.bool,
};
Personnel.defaultProps = { disabled: true };
